"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Escrow = require("./Escrow");
Object.keys(_Escrow).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Escrow[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Escrow[key];
    }
  });
});